import { parse } from 'date-fns';

import { RegisterOptions } from 'react-hook-form';

const CYRILLIC_NAME_REGEX = /^[А-ЯЁ][а-яё-]{1,49}$/;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

function normalizePhoneForValidation(value: string): string {
  return value.replace(/\s|\+/g, '');
}

function validateBirthdate(value: string): true | string {
  if (!value?.trim()) return 'Укажите дату рождения';

  const trimmed = value.trim();
  const dateFormat = /^\d{2}-\d{2}-\d{4}$/;
  if (!dateFormat.test(trimmed)) return 'Введите дату в формате ДД-ММ-ГГГГ';

  let date: Date;
  try {
    date = parse(trimmed, 'dd-MM-yyyy', new Date());
  } catch {
    return 'Введите дату в формате ДД-ММ-ГГГГ';
  }

  if (Number.isNaN(date.getTime())) return 'Указана несуществующая дата';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const birth = new Date(date);
  birth.setHours(0, 0, 0, 0);
  if (birth > today) return 'Дата рождения не может быть в будущем';

  const age = Math.floor(
    (today.getTime() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000),
  );
  if (age < 18) return 'Оформление доступно только с 18 лет';
  if (age > 120) return 'Проверьте корректность даты рождения';

  return true;
}

function optionalSurname(): RegisterOptions {
  return {
    validate: (value: string) => {
      const v = value?.trim() ?? '';
      if (!v) return true;
      if (v.length < 2 || v.length > 50)
        return 'Фамилия должна содержать от 2 до 50 символов';
      if (!CYRILLIC_NAME_REGEX.test(v))
        return 'Фамилия должна быть на кириллице';
      return true;
    },
  } satisfies RegisterOptions;
}

function optionalFirstName(): RegisterOptions {
  return {
    validate: (value: string) => {
      const v = value?.trim() ?? '';
      if (!v) return true;
      if (v.length < 2 || v.length > 50)
        return 'Имя должно содержать от 2 до 50 символов';
      if (!CYRILLIC_NAME_REGEX.test(v)) return 'Имя должно быть на кириллице';
      return true;
    },
  } satisfies RegisterOptions;
}

export const patientFormValidation = {
  surname: optionalSurname(),

  name: optionalFirstName(),

  midname: {
    validate: (value: string) => {
      const v = value?.trim() ?? '';
      if (!v) return true;
      if (v.length < 2 || v.length > 50)
        return 'Отчество должно содержать от 2 до 50 символов';
      if (!CYRILLIC_NAME_REGEX.test(v))
        return 'Отчество должно быть на кириллице';
      return true;
    },
  } satisfies RegisterOptions,

  gender_id: {} satisfies RegisterOptions,

  username: {
    required: 'Укажите номер телефона',
    validate: (value: string) => {
      const raw = value?.trim() ?? '';
      if (!raw) return 'Укажите номер телефона';
      const normalized = normalizePhoneForValidation(raw);
      if (normalized.length !== 11)
        return 'Номер телефона должен содержать 11 цифр';
      if (!/^[78]\d{10}$/.test(normalized))
        return 'Введите корректный номер телефона';
      return true;
    },
  } satisfies RegisterOptions,

  email: {
    validate: (value: string) => {
      const v = value?.trim() ?? '';
      if (!v) return true;
      if (!EMAIL_REGEX.test(v))
        return 'Введите корректный адрес электронной почты';
      return true;
    },
  } satisfies RegisterOptions,

  birthdate: {
    validate: (value: string) => {
      if (!value?.trim()) return true;
      return validateBirthdate(value);
    },
  } satisfies RegisterOptions,
} as const;
